import { Box, Dialog, DialogTitle, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

export const DialogHeader = (props) => {
  return props.children ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 2,
        position: "relative",
      }}
    >
      {typeof props.children === "string" ? (
        <DialogTitle>{props.children}</DialogTitle>
      ) : (
        props.children
      )}

      <IconButton
        aria-label="close"
        onClick={props.onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  ) : (
    <IconButton
      aria-label="close"
      onClick={props.onClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  );
};

export const AppDialog = (
  /**
   * @type {import('@mui/material/Dialog').DialogProps & {
   *  headerContent?: React.ReactNode;
   * }}
   */
  props
) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsModalOpen(props.open);
  }, [props.open]);

  return (
    <Dialog
      {...props}
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onTransitionExited={() => {
        props.onTransitionExited?.();
        props.onClose();
      }}
    >
      <DialogHeader onClose={() => setIsModalOpen(false)}>
        {props.headerContent}
      </DialogHeader>
      {props.children}
    </Dialog>
  );
};
